// import './devgrid.scss'

function init() {

    console.log("hello dev grid");

    // var toggles = $(".grid__toggle"),//various toggles avail.
    var toggles = document.querySelectorAll('.grid__toggle'),
        body = document.querySelector('body'),

        gridIntialInit = false,
        // $container = $('main'),

        //update vars

        devGridOn_rows = false,
        devGridOn_iso = false,
        devGridOn_columns = false,
        devGridOn_baselines = false,
        devGridOn_vertlines = false;


    // review this later - don't need maybe
    //   setgridheight($container, gridIntialInit); // update grid

    toggles.forEach(item => {
        item.addEventListener('click', event => {
            //handle click

            var datatoggle = item.dataset.toggletype, //attr("data-toggle-type"), // review thisnot jquery anaymore
                datatoggletype = datatoggle; //+"-grid";



            //  console.log("data-toggle-type-"+datatoggletype+"");  
            console.log("datatoggletype-" + datatoggletype + "");

            if (item.classList.contains("grid__layer--active")) {

                // if ($(this).hasClass("grid__layer--active")) {

                console.log("." + datatoggletype);
                //  $('.'+datatoggletype).removeClass("grid__layer--active");

                if (datatoggletype == "rows") {
                    devGridOn_rows = false;

                    console.log('devGridOn_rows', devGridOn_rows);

                } else if (datatoggletype == "iso") {
                    devGridOn_iso = false;

                    console.log('devGridOn_iso', devGridOn_iso);

                } else if (datatoggletype == "columns") {
                    devGridOn_columns = false;

                } else if (datatoggletype == "baselines") {
                    devGridOn_baselines = false;

                } else if (datatoggletype == "vertlines") {
                    devGridOn_vertlines = false;

                }

                item.classList.remove("grid__layer--active");
                body.classList.remove("grid__" + datatoggletype + "--active");

                //   $(this).removeClass("grid__layer--active");
                //   $('body').removeClass("grid__" + datatoggletype + "--active");

            } else {

                console.log("." + datatoggletype);


                if (datatoggletype == "rows") {
                    devGridOn_rows = true;


                    console.log('devGridOn_rows', devGridOn_rows);

                } else if (datatoggletype == "iso") {
                    devGridOn_iso = true;

                    console.log('devGridOn_iso', devGridOn_iso);


                } else if (datatoggletype == "columns") {
                    devGridOn_columns = true;

                } else if (datatoggletype == "baselines") {
                    devGridOn_baselines = true;

                } else if (datatoggletype == "vertlines") {
                    devGridOn_vertlines = true;

                }

                // console.log("."+datatoggletype+"-grid");  

                //  $('.'+datatoggletype).addClass("grid__layer--active");
                // $(this).addClass("grid__layer--active");
                // $('body').addClass("grid__" + datatoggletype + "--active");

                item.classList.add("grid__layer--active");
                body.classList.add("grid__" + datatoggletype + "--active");

            } //has class

        }) // item.addEventListener('click', event => {
    }) //    toggles.forEach(item => {



    //     $toggles.each(function () {
    //       // console.log("each");

    //       $(this).click(function () {

    //         var datatoggle = $(this).attr("data-toggle-type"),
    //           datatoggletype = datatoggle; //+"-grid";

    //         //  console.log("data-toggle-type-"+datatoggletype+"");  
    //         console.log("datatoggletype-" + datatoggletype + "");

    //         if ($(this).hasClass("grid__layer--active")) {

    //             console.log("."+datatoggletype);  
    //           //  $('.'+datatoggletype).removeClass("grid__layer--active");

    //           if (datatoggletype == "rows") {
    //             devGridOn_rows = false;

    //             console.log('devGridOn_rows',devGridOn_rows);

    //           } else if (datatoggletype == "iso") {
    //             devGridOn_iso = false;

    //             console.log('devGridOn_iso',devGridOn_iso);

    //           } else if (datatoggletype == "columns") {
    //             devGridOn_columns = false;

    //           } else if (datatoggletype == "baselines") {
    //             devGridOn_baselines = false;

    //           } else if (datatoggletype == "vertlines") {
    //             devGridOn_vertlines = false;

    //           }


    //           $(this).removeClass("grid__layer--active");
    //           $('body').removeClass("grid__" + datatoggletype + "--active");

    //         } else {

    //           console.log("."+datatoggletype);  


    //           if (datatoggletype == "rows") {
    //             devGridOn_rows = true;


    //             console.log('devGridOn_rows',devGridOn_rows);

    //           } else if (datatoggletype == "iso") {
    //             devGridOn_iso = true;

    //             console.log('devGridOn_iso',devGridOn_iso);


    //           } else if (datatoggletype == "columns") {
    //             devGridOn_columns = true;

    //           } else if (datatoggletype == "baselines") {
    //             devGridOn_baselines = true;

    //           } else if (datatoggletype == "vertlines") {
    //             devGridOn_vertlines = true;

    //           }

    //           // console.log("."+datatoggletype+"-grid");  

    //           //  $('.'+datatoggletype).addClass("grid__layer--active");
    //           $(this).addClass("grid__layer--active");
    //           $('body').addClass("grid__" + datatoggletype + "--active");

    //         } //if hasClass



    //       }); ///lcikc

    //     }); ///each
    // //    

}

export default init